import * as React from 'react'
import { ActivityNotificationDropdownConnected } from './ActivityNotificationDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ActivityNotificationDropdownExamples = () => {
  return (
    <div className="ActivityNotificationDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ActivityNotificationDropdownConnected />
      </Provider>
    </div>
  )
}
